import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  padding-bottom: ${props => props.theme.spacing.sp16};
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const LeftFiltersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`
